(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["total-fast-devis"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    const dialog=document.getElementById('TotalFastDevis');
    const configEl=document.getElementById('TotalFastDevisConfig');
    if(!dialog||!configEl||dialog.dataset.ready)return;
    dialog.dataset.ready='true';
    const config=JSON.parse(configEl.textContent),t=config.strings;
    const key='total-fast-devis-v1',pendingKey='total-fast-devis-email';
    const list=dialog.querySelector('[data-ttq-items]'),status=dialog.querySelector('[data-ttq-status]');
    const form=dialog.querySelector('#TotalFastDevisContact'),details=dialog.querySelector('[data-ttq-details]');
    const picker=dialog.querySelector('[data-ttq-picker]');
    const cache=new Map();
    let state={id:'',created:'',items:[]},busy=false,pendingProduct=null,pdfPromise=null,toastTimer,previousFocus,previousOverflow,allowSubmit=false;
    const money=v=>new Intl.NumberFormat(config.locale||'fr',{minimumFractionDigits:3,maximumFractionDigits:3}).format(v/1000)+' '+(config.currency==='TND'?'DT':config.currency);
    const el=(name,cls,text)=>{const n=document.createElement(name);if(cls)n.className=cls;if(text!==undefined)n.textContent=text;return n;};
    function readStored(){
      try{
        const raw=JSON.parse(localStorage.getItem(key)||'null');
        if(raw&&Array.isArray(raw.items)){
          const ids=new Set();
          raw.items=raw.items.filter(i=>i&&/^\d+$/.test(String(i.id))&&typeof i.handle==='string'&&i.handle.length<260&&Number.isInteger(i.quantity)&&i.quantity>0&&i.quantity<=9999&&Number.isSafeInteger(i.price)&&i.price>=0&&!ids.has(String(i.id))&&ids.add(String(i.id)));
          return raw;
        }
      }catch(error){}
      return {id:'',created:'',items:[]};
    }
    function persist(){
      try{localStorage.setItem(key,JSON.stringify(state));}catch(error){announce(t.storage_error,true);}
    }
    function ensureId(){
      if(!state.id){
        const day=new Intl.DateTimeFormat('sv-SE',{timeZone:'Africa/Tunis',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date()).replaceAll('-','');
        state.id='TT-DV-'+day+'-'+crypto.getRandomValues(new Uint32Array(1))[0].toString(36).slice(0,6).toUpperCase();
        state.created=new Date().toISOString();
      }
    }
    function announce(message,error){
      status.textContent=message||'';status.hidden=!message;
      status.classList.toggle('ttq-alert--error',!!error);
    }
    function toast(message){
      const n=document.querySelector('[data-ttq-toast]');clearTimeout(toastTimer);n.textContent=message;n.hidden=false;toastTimer=setTimeout(()=>n.hidden=true,3000);
    }
    function syncButtons(){
      document.querySelectorAll('[data-ttq-count]').forEach(n=>{n.textContent=String(state.items.length);n.hidden=!state.items.length;});
      document.querySelectorAll('[data-ttq-add]').forEach(b=>{
        const selected=state.items.some(i=>i.handle===b.dataset.ttqHandle);
        b.setAttribute('aria-pressed',String(selected));
        const label=b.querySelector('[data-ttq-add-label]');const text=selected?t.selected:t.add;if(label&&label.textContent!==text)label.textContent=text;
      });
    }
    function render(){
      const focus=document.activeElement?.dataset.ttqQuantity;
      list.replaceChildren();
      state.items.forEach(item=>{
        const li=el('li','ttq-item');li.dataset.ttqItem=item.id;
        if(item.image){const img=el('img','ttq-item-image');img.src=item.image;img.alt='';img.width=60;img.height=60;img.loading='lazy';li.append(img);}
        else li.append(el('span','ttq-item-image'));
        const info=el('div','ttq-item-info'),a=el('a','ttq-item-title',item.title);
        a.href=config.root+'products/'+encodeURIComponent(item.handle)+'?variant='+encodeURIComponent(item.id);
        info.append(a);
        if(item.variant&&item.variant!=='Default Title')info.append(el('p','ttq-item-meta',item.variant));
        if(item.sku)info.append(el('p','ttq-item-meta',t.reference+' : '+item.sku));
        info.append(el('p','ttq-item-meta',t.unit+' : '+money(item.price)));
        const controls=el('div','ttq-item-controls'),label=el('label','ttq-quantity',t.quantity);
        const input=el('input');input.type='number';input.min='1';input.max='9999';input.step='1';input.required=true;input.value=String(item.quantity);input.inputMode='numeric';input.dataset.ttqQuantity=item.id;input.setAttribute('aria-label',t.quantity+' — '+item.title);
        label.append(input);controls.append(label,el('strong','ttq-line-total',money(item.price*item.quantity)));
        const remove=el('button','ttq-remove',t.remove);remove.type='button';remove.dataset.ttqRemove=item.id;remove.setAttribute('aria-label',t.remove+' — '+item.title);controls.append(remove);
        info.append(controls);
        if(item.invalid)info.append(el('p','ttq-item-error',t.unavailable));
        li.append(info);list.append(li);
      });
      const has=state.items.length>0;
      dialog.querySelector('[data-ttq-empty]').hidden=has;
      dialog.querySelector('[data-ttq-summary]').hidden=!has;
      dialog.querySelector('[data-ttq-price-note]').hidden=!has;
      details.hidden=!has;
      dialog.querySelector('[data-ttq-total]').textContent=money(state.items.reduce((sum,i)=>sum+i.price*i.quantity,0));
      dialog.querySelector('[data-ttq-heading-count]').textContent=has?'('+state.items.length+')':'';
      dialog.querySelectorAll('[data-ttq-download],[data-ttq-email],[data-ttq-send]').forEach(b=>b.disabled=!has||busy);
      list.querySelectorAll('input,button').forEach(n=>n.disabled=busy);
      syncButtons();
      if(focus)list.querySelector('[data-ttq-quantity="'+focus+'"]')?.focus({preventScroll:true});
    }
    function open(){
      if(!dialog.open){
        previousFocus=document.activeElement;previousOverflow=document.documentElement.style.overflow;
        document.documentElement.style.overflow='hidden';dialog.showModal();
        document.getElementById('TotalFastDevisTitle').focus({preventScroll:true});
      }
      render();
    }
    dialog.addEventListener('close',()=>{document.documentElement.style.overflow=previousOverflow||'';if(previousFocus?.isConnected)previousFocus.focus({preventScroll:true});});
    dialog.addEventListener('click',event=>{if(event.target===dialog){const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close();}});
    async function product(handle,fresh){
      if(!fresh&&cache.has(handle))return cache.get(handle);
      const request=(async()=>{
        const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),15000);
        try{
          const r=await fetch(config.root+'products/'+encodeURIComponent(handle)+'.js',{headers:{Accept:'application/json'},cache:'no-store',signal:controller.signal});
          if(!r.ok)throw new Error('product');
          const p=await r.json();if(!Array.isArray(p.variants)||!p.title)throw new Error('product');return p;
        }finally{clearTimeout(timer);}
      })();
      cache.set(handle,request);
      try{return await request;}catch(error){cache.delete(handle);throw error;}
    }
    function snapshot(p,v,quantity){
      const price=Math.round(Number(v.price)*10);
      if(!Number.isSafeInteger(price)||price<0)throw new Error('price');
      const image=v.featured_image?.src||p.featured_image||'';
      return {id:String(v.id),handle:p.handle,title:p.title,variant:v.public_title||v.title,sku:v.sku||'',price,quantity,image:typeof image==='string'?image:''};
    }
    function add(p,v,quantity){
      const existing=state.items.find(i=>i.id===String(v.id));
      if(existing){open();list.querySelector('[data-ttq-item="'+existing.id+'"]')?.scrollIntoView({block:'nearest'});return;}
      ensureId();state.items.push(snapshot(p,v,quantity));persist();render();announce('');toast(t.added);
    }
    async function select(button){
      button.disabled=true;
      try{
        const handle=button.dataset.ttqHandle;
        if(button.dataset.ttqContext==='card'&&state.items.some(i=>i.handle===handle)){open();return;}
        const p=await product(handle);
        let id=button.dataset.ttqVariant,quantity=1;
        if(button.dataset.ttqContext==='product'){
          const area=button.closest('article')||button.closest('.shopify-section');
          const productForm=area?.querySelector('form[action*="/cart/add"]');
          id=productForm?.querySelector('[name="id"]')?.value||id;
          const n=Number(productForm?.querySelector('[name="quantity"]')?.value||1);if(Number.isInteger(n)&&n>0&&n<=9999)quantity=n;
        }
        let v=p.variants.find(v=>String(v.id)===String(id));
        if(!v&&p.variants.length===1)v=p.variants[0];
        if(v){add(p,v,quantity);return;}
        pendingProduct=p;picker.hidden=false;picker.querySelector('[data-ttq-picker-title]').textContent=p.title;
        const choices=picker.querySelector('[data-ttq-picker-variant]');choices.replaceChildren();
        p.variants.forEach(v=>{const option=el('option','',(v.public_title||v.title)+' — '+money(Math.round(Number(v.price)*10)));option.value=String(v.id);choices.append(option);});
        picker.querySelector('[data-ttq-picker-quantity]').value=String(quantity);open();picker.scrollIntoView({block:'start'});choices.focus();
      }catch(error){open();announce(t.error,true);}finally{button.disabled=false;syncButtons();}
    }
    async function refresh(){
      const handles=[...new Set(state.items.map(i=>i.handle))],products=new Map();let failed=false;
      const queue=handles.slice();
      await Promise.all(Array.from({length:Math.min(4,queue.length)},async()=>{
        while(queue.length){const handle=queue.shift();try{products.set(handle,await product(handle,true));}catch(error){failed=true;}}
      }));
      if(failed)throw new Error(t.error);
      let invalid=false;
      state.items=state.items.map(i=>{
        const p=products.get(i.handle),v=p?.variants.find(v=>String(v.id)===i.id);
        if(!v){invalid=true;return {...i,invalid:true};}
        return snapshot(p,v,i.quantity);
      });
      persist();render();if(invalid)throw new Error(t.unavailable);
    }
    function fields(){
      return Object.fromEntries(Array.from(form.querySelectorAll('[data-ttq-field]')).map(n=>[n.dataset.ttqField,n.value.trim()]));
    }
    function data(){
      return {config,strings:t,id:state.id,created:state.created,items:state.items.map(i=>({...i})),client:fields(),total:state.items.reduce((s,i)=>s+i.price*i.quantity,0)};
    }
    async function prepare(){
      if(busy||!state.items.length)return false;
      for(const n of list.querySelectorAll('[data-ttq-quantity]')){
        if(!n.reportValidity())return false;
        const item=state.items.find(i=>i.id===n.dataset.ttqQuantity);if(item)item.quantity=Number(n.value);
      }
      persist();
      busy=true;render();announce(t.busy);
      try{await refresh();return true;}catch(error){announce(error.message||t.error,true);return false;}
      finally{busy=false;render();}
    }
    function loadPdf(){
      if(window.TotalDevisPDF)return Promise.resolve(window.TotalDevisPDF);
      if(pdfPromise)return pdfPromise;
      pdfPromise=new Promise((resolve,reject)=>{
        const s=document.createElement('script');s.src=config.pdf_script;s.async=true;s.onload=()=>window.TotalDevisPDF?resolve(window.TotalDevisPDF):reject(new Error(t.pdf_error));s.onerror=()=>{s.remove();pdfPromise=null;reject(new Error(t.pdf_error));};document.head.append(s);
      });
      return pdfPromise;
    }
    async function download(){
      if(!await prepare())return;
      busy=true;render();announce(t.pdf_busy);
      try{const pdf=await loadPdf();await pdf.download(data());announce('');}
      catch(error){announce(error.message||t.pdf_error,true);}
      finally{busy=false;render();}
    }
    function emailMode(){
      if(!state.items.length||busy)return;
      details.open=true;dialog.querySelector('[data-ttq-email-area]').hidden=false;
      details.scrollIntoView({block:'start',behavior:'smooth'});
      form.querySelector('[data-ttq-field="name"]').focus({preventScroll:true});
    }
    function emailBody(d){
      const lines=[t.quote+' '+d.id,new Date().toLocaleString('fr-TN',{timeZone:'Africa/Tunis'}),config.brand,t.official,...config.addresses,config.email,config.website,''];
      for(const [key,value]of Object.entries(d.client))if(value)lines.push((t[key==='email'?'email_label':key]||key)+' : '+value);
      lines.push('');
      d.items.forEach((i,n)=>{lines.push((n+1)+'. '+i.title+(i.variant&&i.variant!=='Default Title'?' — '+i.variant:''),t.reference+' : '+i.sku,t.quantity+' : '+i.quantity+' | '+t.unit+' : '+money(i.price)+' | '+t.total+' : '+money(i.price*i.quantity),config.website+'/products/'+encodeURIComponent(i.handle)+'?variant='+i.id,'');});
      lines.push(t.total+' : '+money(d.total),t.note);
      return lines.join('\n');
    }
    document.addEventListener('click',event=>{
      if(!(event.target instanceof Element))return;
      const addButton=event.target.closest('[data-ttq-add]');
      if(addButton){event.preventDefault();event.stopImmediatePropagation();if(!busy)select(addButton);return;}
      const opener=event.target.closest('[data-ttq-open]');
      if(opener){event.preventDefault();event.stopImmediatePropagation();open();return;}
      if(event.target.closest('[data-ttq-close]')){dialog.close();return;}
      const remove=event.target.closest('[data-ttq-remove]');
      if(remove&&!busy){state.items=state.items.filter(i=>i.id!==remove.dataset.ttqRemove);if(!state.items.length){state.id='';state.created='';}persist();render();announce('');return;}
      if(event.target.closest('[data-ttq-download]'))download();
      if(event.target.closest('[data-ttq-email]'))emailMode();
      if(event.target.closest('[data-ttq-email-back]')){dialog.querySelector('[data-ttq-email-area]').hidden=true;details.open=false;}
      if(event.target.closest('[data-ttq-picker-cancel]')){picker.hidden=true;pendingProduct=null;}
      if(event.target.closest('[data-ttq-picker-add]')&&pendingProduct){
        const qty=picker.querySelector('[data-ttq-picker-quantity]');if(!qty.reportValidity())return;
        const v=pendingProduct.variants.find(v=>String(v.id)===picker.querySelector('[data-ttq-picker-variant]').value);
        if(v){add(pendingProduct,v,Number(qty.value));picker.hidden=true;pendingProduct=null;}
      }
    },true);
    function updateQuantity(event,report){
      const n=event.target;if(!n.matches('[data-ttq-quantity]')||busy)return;
      if(!n.validity.valid){if(report)n.reportValidity();return;}
      const quantity=Number(n.value);if(!Number.isInteger(quantity)||quantity<1||quantity>9999)return;
      const item=state.items.find(i=>i.id===n.dataset.ttqQuantity);
      if(item){
        item.quantity=quantity;persist();
        n.closest('[data-ttq-item]').querySelector('.ttq-line-total').textContent=money(item.price*item.quantity);
        dialog.querySelector('[data-ttq-total]').textContent=money(state.items.reduce((sum,i)=>sum+i.price*i.quantity,0));
      }
    }
    list.addEventListener('input',event=>updateQuantity(event,false));
    list.addEventListener('change',event=>updateQuantity(event,true));
    form.addEventListener('submit',async event=>{
      if(allowSubmit)return;
      event.preventDefault();if(!await prepare())return;
      const d=data();form.querySelector('[data-ttq-email-body]').value=emailBody(d);form.querySelector('[data-ttq-email-id]').value=state.id;
      try{sessionStorage.setItem(pendingKey,state.id);}catch(error){}
      allowSubmit=true;
      try{form.requestSubmit(form.querySelector('[data-ttq-send]'));}finally{allowSubmit=false;}
    });
    window.addEventListener('storage',event=>{if(event.key===key&&!busy){state=readStored();render();}});
    document.addEventListener('shopify:section:load',syncButtons);
    const main=document.querySelector('main');
    if(main){let scheduled=false;new MutationObserver(()=>{if(!scheduled){scheduled=true;requestAnimationFrame(()=>{scheduled=false;syncButtons();});}}).observe(main,{childList:true,subtree:true});}
    state=readStored();render();
    const server=dialog.querySelector('[data-ttq-server-state]');
    try{
      if(sessionStorage.getItem(pendingKey)){
        sessionStorage.removeItem(pendingKey);open();
        if(server.dataset.success==='true')announce(t.success);
        else{details.open=true;dialog.querySelector('[data-ttq-email-area]').hidden=false;if(server.dataset.errors!=='true')announce(t.error,true);}
      }
    }catch(error){}
    window.addEventListener('pageshow',()=>{busy=false;allowSubmit=false;render();});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["total-money-display"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '.money, .Vtl-Money';
  const pattern = /(-?\d[\d,\u00a0\u202f ]*(?:\.\d+)?)\s*(?:TND|DT)\b/g;
  const compact = text => text.replace(pattern, (_, amount) => {
    let value = amount.trim();
    if (value.includes('.')) value = value.replace(/0+$/, '').replace(/\.$/, '');
    return `${value} DT`;
  });
  function format(element) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const value = compact(node.nodeValue);
      if (value !== node.nodeValue) node.nodeValue = value;
    }
  }
  function scan(root) {
    if (root.nodeType !== Node.ELEMENT_NODE) return;
    if (root.matches(selector)) format(root);
    root.querySelectorAll(selector).forEach(format);
  }
  function start() {
    scan(document.body);
    const pending = new Set();
    let frame = 0;
    new MutationObserver(records => {
      records.forEach(record => {
        const element = record.target.nodeType === Node.TEXT_NODE ? record.target.parentElement : record.target;
        const price = element.closest?.(selector);
        if (price) pending.add(price);
        record.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) pending.add(node);
        });
      });
      if (frame || !pending.size) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        pending.forEach(node => { if (node.isConnected) scan(node); });
        pending.clear();
      });
    }).observe(document.body, {childList: true, characterData: true, subtree: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
